import React from 'react';
import { Link } from 'react-router-dom';
import Format from '../../../utils/format';
import Const from '../../../constants';
import APPLICATION_TYPE from '../../../constants/application-type';
import { Spinner } from '@graffer-inc/graffer-ui';

const EntryDetailInfo = ({ entry, canEdit, isLoading }) => isLoading ? (
  <div
    className="has-text-centered flat-box"
    style={{ padding: "60px 0" }}
  >
    <Spinner />
  </div>
) : (
  <div className="flat-box">
    <p className="is-size-6 title">
      <span>申込内容</span>
      {canEdit && (
        <Link
          style={{ paddingLeft: '5px' }}
          className="is-size-7 has-text-weight-normal"
          to='/entries/new'
        >
          変更
        </Link>
      )}
    </p>
    <p className="is-size-6" style={{paddingBottom: '15px'}}>
      <span className="is-size-7 has-text-weight-bold" style={{display: 'inline-block', width: '160px'}}>
        電子証明書の証明期間
      </span>
      <span>
        {entry.certPeriod}ヵ月 - {Format.money(Const.MASTER.CERT_PERIOD.find(c => c.period === Number(entry.certPeriod)).price)}円(発行手数料)
      </span>
    </p>
    <p className="is-size-6" style={{paddingBottom: '15px'}}>
      <span className="is-size-7 has-text-weight-bold" style={{display: 'inline-block', width: '160px'}}>
        申請プラン
      </span>
      <span>
        {APPLICATION_TYPE.name(entry.applicationType)}プラン
      </span>
    </p>
    <div style={{paddingBottom: '15px'}}>
      <span className="is-size-7 has-text-weight-bold" style={{display: 'inline-block', width: '160px'}}>
        申請者
      </span>
      <span>
        {entry.isAttorneyApplication ? '代理人': '印鑑提出者本人'}
      </span>
      {
        entry.isAttorneyApplication && (
          <div style={{paddingLeft: '10px'}} className="is-size-6">
            <p>
            <span className="has-text-weight-bold is-size-7" style={{display: 'inline-block', width: '150px'}}>
              代理人の現住所
            </span>
              <span>
              {entry.attorneyAddress}
            </span>
            </p>
            <p>
            <span className="has-text-weight-bold is-size-7" style={{display: 'inline-block', width: '150px'}}>
              代理人の氏名
            </span>
              <span>
              {entry.attorneyName}
            </span>
            </p>
          </div>
        )
      }
    </div>
    <p className="is-size-6" style={{paddingBottom: '15px'}}>
      <span className="is-size-7 has-text-weight-bold" style={{display: 'inline-block', width: '160px'}}>
        発行手数料分の収入印紙
      </span>
      <span>
        {entry.isWithRevenueStamp ? 'セットでつける' : 'セットでつけない'}
      </span>
    </p>
    {
      typeof (entry.isRegistryCertsRegistration) === 'boolean' && (
        <>
          <p className="is-size-7 has-text-weight-bold" style={{paddingBottom: '15px'}}>
            発行した電子証明書とパスワードをアカウントに登録{entry.isRegistryCertsRegistration ? 'する' : 'しない'}
          </p>
          <p className="is-size-7 has-text-grey">登録いただいたシリアル番号と電子証明書パスワードはセキュリティの観点から表示されません。<br/>電子証明書パスワードは再設定ができないため、忘れないよう大切に保管してください。</p>
        </>
      )
    }
  </div>
);

export default EntryDetailInfo;
